import { render, staticRenderFns } from "./phone-edit-modal.vue?vue&type=template&id=25519b4a&"
import script from "./phone-edit-modal.vue?vue&type=script&lang=js&"
export * from "./phone-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./phone-edit-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25519b4a')) {
      api.createRecord('25519b4a', component.options)
    } else {
      api.reload('25519b4a', component.options)
    }
    module.hot.accept("./phone-edit-modal.vue?vue&type=template&id=25519b4a&", function () {
      api.rerender('25519b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/phone-edit-modal.vue"
export default component.exports